import * as React from "react";
import * as DetailTopBar from "./DetailTopBar";
import { withRouter } from "react-router";
import { dashboards } from "app/components/AppComponents/Dashboards";

class DashboardsTopBar extends React.Component<any, any> {
  render() {
    return (
      <DetailTopBar.Bar>
        {dashboards.map((dashboard, i) => (
          <DetailTopBar.Item
            key={i}
            text={dashboard.name}
            link={`/snapscan/ops/dashboards/${dashboard.name}`}
          />
        ))}
      </DetailTopBar.Bar>
    );
  }
}

export default withRouter(DashboardsTopBar);
